export const REPORT_SCHEMA_VERSION_V2 = 2;

export const REPORT_SEMANTIC_TYPES = Object.freeze({
  RESULT: "RESULT",
  PLAYING: "PLAYING",
  NO_SHOW: "NO_SHOW",
  RAGE_QUIT: "RAGE_QUIT",
  CONNECTION_ISSUE: "CONNECTION_ISSUE",
});

const LEGACY_OPTION_TO_SEMANTIC_TYPE = Object.freeze({
  A: REPORT_SEMANTIC_TYPES.RESULT,
  B: REPORT_SEMANTIC_TYPES.PLAYING,
  C: REPORT_SEMANTIC_TYPES.NO_SHOW,
  D: REPORT_SEMANTIC_TYPES.RAGE_QUIT,
  E: REPORT_SEMANTIC_TYPES.CONNECTION_ISSUE,
});

const V2_OPTION_TO_SEMANTIC_TYPE = Object.freeze({
  A: REPORT_SEMANTIC_TYPES.RESULT,
  B: REPORT_SEMANTIC_TYPES.PLAYING,
  C: REPORT_SEMANTIC_TYPES.RAGE_QUIT,
  D: REPORT_SEMANTIC_TYPES.CONNECTION_ISSUE,
});

function normalizeUpper(value) {
  return String(value ?? "").trim().toUpperCase();
}

function getOptionCode(report = {}) {
  return normalizeUpper(
    report?.optionCode ?? report?.option ?? report?.type ?? report?.reportType ??
    report?.payload?.optionCode ?? report?.payload?.option ??
    report?.payload?.type ?? report?.payload?.reportType
  );
}

export function resolveReportSemantics(report = {}) {
  if (!report || typeof report !== "object" || Array.isArray(report)) {
    throw new Error("invalid-report");
  }
  const rawVersion = report?.reportSchemaVersion ?? report?.schemaVersion;
  const hasVersion = rawVersion !== undefined && rawVersion !== null && rawVersion !== "";
  const schemaVersion = hasVersion ? Number(rawVersion) : 1;
  const optionCode = getOptionCode(report);

  if (schemaVersion === 1) {
    const semanticType = LEGACY_OPTION_TO_SEMANTIC_TYPE[optionCode];
    if (!semanticType) throw new Error("unknown-legacy-option");
    return { schemaVersion: 1, semanticType, optionCode, isLegacy: true };
  }
  if (schemaVersion !== REPORT_SCHEMA_VERSION_V2) throw new Error("unsupported-schema-version");

  const semanticType = normalizeUpper(report.semanticType);
  const expectedSemanticType = V2_OPTION_TO_SEMANTIC_TYPE[optionCode];
  if (!Object.values(V2_OPTION_TO_SEMANTIC_TYPE).includes(semanticType)) {
    throw new Error("unknown-semantic-type");
  }
  if (!expectedSemanticType) throw new Error("invalid-v2-option");
  if (semanticType !== expectedSemanticType) throw new Error("inconsistent-v2-report");
  return { schemaVersion: 2, semanticType, optionCode, isLegacy: false };
}

export function tryResolveReportSemantics(report = {}) {
  try {
    return resolveReportSemantics(report);
  } catch (_) {
    return null;
  }
}
